var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomGiftsPrimary = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.284 42.548v23.578a3.93 3.93 0 0 0 3.939 3.938h19.639V42.548H12.284zM67.316 26.847H54.862a13.547 13.547 0 0 0 2.182-1.756 8.16 8.16 0 0 0 0-11.55c-3.086-3.086-8.462-3.086-11.549 0-1.703 1.704-6.227 8.676-5.588 13.306h-.266c.638-4.63-3.886-11.602-5.589-13.305-3.087-3.087-8.462-3.087-11.549 0a8.16 8.16 0 0 0 0 11.549c.532.532 1.33 1.17 2.182 1.756H12.231a3.93 3.93 0 0 0-3.938 3.939v5.908c0 1.064.904 1.969 1.969 1.969h25.547v-7.877h7.877v7.877h25.546c1.065 0 1.97-.905 1.97-1.97v-5.907c.053-2.182-1.703-3.939-3.886-3.939zm-31.667-.16s-.16.107-.745.107c-2.714 0-7.877-2.82-9.58-4.524-1.65-1.65-1.65-4.364 0-6.014a4.186 4.186 0 0 1 2.98-1.224c1.118 0 2.182.426 2.98 1.224 2.609 2.714 5.27 9.527 4.365 10.432zm9.048.16c-.532 0-.745-.106-.745-.106-.905-.958 1.703-7.77 4.364-10.432 1.597-1.596 4.364-1.596 5.96 0 1.65 1.65 1.65 4.365 0 6.014-1.702 1.704-6.865 4.524-9.58 4.524zM43.739 42.548v27.516h19.639a3.93 3.93 0 0 0 3.938-3.938V42.548H43.74z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomGiftsPrimary);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-gifts-primary.9543f05d05f0b0f60f51f116f8093e8c.svg";